import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface YearWithInvestments {
  year: number;
  dyId: number;
  investments: any[];
}

@Component({
  selector: 'app-social-investments-copy-dialog',
  template: `
    <h2 mat-dialog-title>Copy Social Investment from Another Year</h2>
    <mat-dialog-content style="width: 700px; max-height: 70vh;">
      @if (data.years.length === 0) {
        <p>No other years with social investments available.</p>
      } @else {
        <div style="display: flex; gap: 24px; overflow: hidden;">
          <div style="flex: 0 0 240px; overflow: hidden;">
            <p style="margin: 0 0 4px"><strong>1. Select year</strong></p>
            <mat-selection-list [multiple]="false" (selectionChange)="onYearSelected($event)">
              @for (y of data.years; track y.dyId) {
                <mat-list-option [value]="y">
                  {{ y.year }}
                  <span style="color: gray; font-size: 0.85em">
                    &nbsp;({{ y.investments.length }})
                  </span>
                </mat-list-option>
              }
            </mat-selection-list>
          </div>
          <div style="flex: 1; min-width: 0; overflow: hidden;">
            @if (selectedYear) {
              <p style="margin: 0 0 4px"><strong>2. Select investment</strong></p>
              <mat-selection-list [multiple]="false" (selectionChange)="onInvestmentSelected($event)">
                @for (inv of selectedYear.investments; track inv.id) {
                  <mat-list-option [value]="inv" style="overflow: hidden;">
                    <span style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ inv.name || '(unnamed)' }}
                    </span>
                  </mat-list-option>
                }
              </mat-selection-list>
            }
          </div>
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button color="primary" [disabled]="!selectedInvestment" (click)="confirm()">Copy</button>
    </mat-dialog-actions>
  `,
  standalone: false,
})
export class SocialInvestmentsCopyDialogComponent {
  selectedYear: YearWithInvestments | null = null;
  selectedInvestment: any | null = null;

  constructor(
    public dialogRef: MatDialogRef<SocialInvestmentsCopyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { years: YearWithInvestments[] }
  ) {}

  onYearSelected(event: any): void {
    this.selectedYear = event.options[0]?.value ?? null;
    this.selectedInvestment = null;
  }

  onInvestmentSelected(event: any): void {
    this.selectedInvestment = event.options[0]?.value ?? null;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedInvestment);
  }
}
